var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "notice-container"
  }, [_c('div', {
    staticClass: "heading-icon",
    staticStyle: {
      "background-color": "#2a9d8f"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
    }
  }), _c('polyline', {
    attrs: {
      "points": "14,2 14,8 20,8"
    }
  }), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "13",
      "x2": "8",
      "y2": "13"
    }
  }), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "17",
      "x2": "8",
      "y2": "17"
    }
  }), _c('polyline', {
    attrs: {
      "points": "10,9 9,9 8,9"
    }
  })])]), _c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v("體檢／健檢掛號須知")]), _vm._m(0)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "notice-content"
  }, [_c('p', {
    staticClass: "notice-subtitle"
  }, [_vm._v(" 攸關您的就診權益，在進行掛號前請詳細閱讀 ")]), _c('ol', {
    staticClass: "notice-list"
  }, [_c('li', {
    staticClass: "notice-item"
  }, [_c('div', {
    staticClass: "notice-item-title"
  }, [_vm._v("1. 完成線上掛號後，看診當日請記得攜帶健保卡、身分證前至掛號櫃檯現場報到")])]), _c('li', {
    staticClass: "notice-item"
  }, [_c('div', {
    staticClass: "notice-item-title"
  }, [_vm._v("2. 最晚報到時間為："), _c('span', {
    staticClass: "highlight-text"
  }, [_vm._v("11:00 (上午診)")]), _vm._v("、"), _c('span', {
    staticClass: "highlight-text"
  }, [_vm._v("5:00 (下午診)")]), _vm._v("、"), _c('span', {
    staticClass: "highlight-text"
  }, [_vm._v("9:00 (夜診)")])])]), _c('li', {
    staticClass: "notice-item"
  }, [_c('div', {
    staticClass: "notice-item-title"
  }, [_vm._v("3. 當日不開放網路預約，若預約額滿，請至現場掛號")])]), _c('li', {
    staticClass: "notice-item"
  }, [_c('div', {
    staticClass: "notice-item-title"
  }, [_vm._v("4. 為維護看診品質，現場報到情況限制看診人數，建議提早掛號")])])])]);
}]

export { render, staticRenderFns }